<script setup lang="ts">
import type { SelectScrollDownButtonProps } from "reka-ui"
import { SelectScrollDownButton } from "reka-ui"
import { ChevronDownIcon } from "lucide-vue-next"

const props = defineProps<SelectScrollDownButtonProps>()
</script>

<template>
  <SelectScrollDownButton v-bind="props" class="flex cursor-default items-center justify-center py-1">
    <ChevronDownIcon class="size-4" />
  </SelectScrollDownButton>
</template>
